











import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { AvatarHelper } from '@getaccept/lib-shared/src/helpers/avatars.helper';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';

export default defineComponent({
  name: 'RecipientList',
  props: {
    recipients: {
      type: Array as PropType<Recipient[]>,
      default: () => [],
    },
  },
  setup() {
    return {
      displayName: AvatarHelper.getDisplayName,
    };
  },
});
